import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeModule } from './home/home.module';
import { DestinationsModule } from './destinations/destinations.module';
import { ServicesModule } from './services/services.module';
import { ContactsModule } from './contacts/contacts.module';
import { CommerceModule } from './commerce/commerce.module';
import { ReservationModule } from './reservation/reservation.module';
import { PricingModule } from './pricing/pricing.module';
import { FaqModule } from './faq/faq.module';
import { ContractModule } from './contract/contract.module';

import { MatDialogModule } from '@angular/material/dialog';
import { AppComponent } from './app.component';
import localeIt from '@angular/common/locales/it';
import { DecimalPipe, registerLocaleData } from '@angular/common';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
registerLocaleData(localeIt);
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    HomeModule,
    ContractModule,
    DestinationsModule,
    ServicesModule,
    PricingModule,
    FaqModule,
    ContactsModule,
    CommerceModule,
    ReservationModule,
    MatDialogModule,
  ],
  providers: [
    DecimalPipe,
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: LOCALE_ID, useValue: 'it-IT' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
